export default "__VITE_ASSET__C64W1MtW__"